import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import Select from '../shared/reactSelect/select.component';
import PeriodDropdown from '../shared/periodDropdown.component';
import SecondaryMenu from '../menu/secondaryMenu.component';
import { modalDataSelector } from '../shared/modals/modals.selectors';

import {
  fetchProvisionData,
  selectCompanyCode,
  selectPeriod,
} from '../shared/store/actions';

import {
  periodOrCurrentSelector,
  periodsSelector,
  environmentSuffixSelector,
  companyCodesOptions,
  companyCodeSelector,
} from '../shared/store/selectors';

import {
  calculateProvision,
  showCannotCalculateMessageModal,
  hideCannotCalculateMessageModal,
  hideBatchCalculationModal,
  showCannotUploadMessageModal,
  hideCannotUploadMessageModal,
  proformaCalc,
  downloadProvisionDetails,
} from './store/actions';

import {
  uploadTrialBalanceFile,
} from './trialBalanceTab/store/actions';

import HamburgerDropdown from './hamburgerDropdown.component';
import ProvisionDetails, { TabTypes } from './provisionDetails.component';

import AccessRestricted from '../shared/authorization/accessRestricted.component';
import { withViewPermission } from '../shared/authorization';
import NoDataToDisplay from '../shared/noDataToDisplay.component';
import { ReduxAlert } from '../shared/alert.component';

import {
  cannotUploadTrialBalanceSelector,
  cannotCalculateTrialBalanceSelector,
  cannotDownloadCompanyDetailsSelector,
  adjustmentsSelector,
  isDownloadingProvisionDetailsSelector,
} from './store/selectors';
import { ModalNames } from './constants';
import BatchCalculationModal from './batchCalculationModal.component';
import CannotCalculateMessageModal from './cannotCalculateMessageModal.component';
import CannotUploadMessageModal from './cannotUploadMessageModal.component';
import AddEditAdjustmentModal from './addEditAdjustmentModal/addEditAdjustmentModal.component';
import DeleteAdjustmentModal from './deleteAdjustmentModal/deleteAdjustmentsModal.component';
import AttachmentsModal from './attachmentsModal/attachmentsModal.component';
import { hideAdjustmentModalForAddEdit, hideDeleteModal } from './adjustmentsTab/store/actions';

import { journalsPropTypes, localJournalsPropTypes, journalsDetailPropTypes } from '../shared/propTypes';
import { AdjustmentsCollectionPropTypes } from '../shared/propTypes/adjustments';
import { BookToTaxDifferencesCollectionPropTypes } from '../shared/propTypes/bookToTaxDifferences';
import { TaxRatesPropTypes } from './calculationSettingsTab/taxRates.component';
import { TaxAccountingPropTypes } from './calculationSettingsTab/taxAccounting.component';
import { BookToTaxDifferencesPropTypes } from './calculationSettingsTab/bookToTaxDifferences.component';

import { hideDecimalsSelector, negativeMinusSelector, displayZeroSelector } from '../userData/store/selectors';
import Spinner from '../shared/spinner.component';
import { trialBalancePropTypes } from './propTypes';


class ProvisionPage extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    calculateProvision: PropTypes.func.isRequired,
    proformaCalc: PropTypes.func.isRequired,
    uploadTrialBalanceFile: PropTypes.func.isRequired,
    companyCode: PropTypes.string,
    companyCodes: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    fetchProvisionData: PropTypes.func.isRequired,
    selectCompanyCode: PropTypes.func.isRequired,
    selectPeriod: PropTypes.func.isRequired,
    general: PropTypes.shape({
      countryName: PropTypes.string,
      functionalCurrency: PropTypes.string,
      labelTag: PropTypes.string,
      lastTbFlag: PropTypes.string,
      name: PropTypes.string,
      periodName: PropTypes.string,
      statusName: PropTypes.string,
      updatedOn: PropTypes.string,
      companyCodeDetails: PropTypes.shape({
        businessUnit: PropTypes.string,
        companySource: PropTypes.string,
        chartName: PropTypes.string,
      }),
    }),

    adjustments: PropTypes.shape({
      showDeleteModal: PropTypes.bool,
      showAttachmentsModal: PropTypes.bool,

      adjustmentsCollection: AdjustmentsCollectionPropTypes,
      bookToTaxDifferencesCollection: BookToTaxDifferencesCollectionPropTypes,
    }),
    addEditAdjustmentModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.shape({
        countryTaxType: PropTypes.string,
        adjustmentType: PropTypes.string,
        multiTaxNonUSTaxAmountInfo: PropTypes.string,
        account: PropTypes.string,
        description: PropTypes.string,
        amountFrom: PropTypes.number,
        frequency: PropTypes.string,
        amount: PropTypes.number,
        amountInfo: PropTypes.string,
        multiplier: PropTypes.number,
        annualCum: PropTypes.string,
        bookToTaxDescription: PropTypes.string,
        files: PropTypes.arrayOf(PropTypes.instanceOf(File)),
        calendar: PropTypes.string,
      }),
    }).isRequired,
    hideAdjustmentModalForAddEdit: PropTypes.func.isRequired,

    deleteAdjustmentModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.shape({
        adjustmentId: PropTypes.string.isRequired,
        autoAdjustmentId: PropTypes.number,
      }),
    }).isRequired,
    hideDeleteModal: PropTypes.func.isRequired,

    attachmentsModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.shape({
        adjustmentId: PropTypes.number.isRequired,
        description: PropTypes.string.isRequired,
      }),
    }).isRequired,
    uploadTrialBalanceModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }),

    fetchingInitialProvisionData: PropTypes.bool,
    isCalculatingProvision: PropTypes.bool,
    isProformaCalc: PropTypes.bool,
    isUploadingTrialBalance: PropTypes.bool,
    isMultiTaxNonUS: PropTypes.bool,
    hasViewAccess: PropTypes.bool.isRequired,

    cannotUploadTrialBalance: PropTypes.bool.isRequired,
    cannotUploadMessageModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }).isRequired,
    cannotCalculateTrialBalance: PropTypes.bool.isRequired,
    cannotCalculateMessageModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }).isRequired,

    cannotDownloadCompanyDetails: PropTypes.bool.isRequired,

    showCannotUploadMessageModal: PropTypes.func.isRequired,
    hideCannotUploadMessageModal: PropTypes.func.isRequired,
    showCannotCalculateMessageModal: PropTypes.func.isRequired,
    hideCannotCalculateMessageModal: PropTypes.func.isRequired,
    hideBatchCalculationModal: PropTypes.func.isRequired,
    batchCalculationModal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }).isRequired,

    errorMessage: PropTypes.string,

    taxExpense: PropTypes.shape({
      US_TED: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
      TED_NON_US_GAAP: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
      TED_NON_US_STAT: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
    }),
    trialBalanceCollection: PropTypes.arrayOf(trialBalancePropTypes).isRequired,
    journalsCollection: journalsPropTypes,
    localJournalsCollection: localJournalsPropTypes,
    journalsDetailCollection: journalsDetailPropTypes,
    taxRates: TaxRatesPropTypes,
    taxAccounting: TaxAccountingPropTypes,
    bookToTaxDifferences: BookToTaxDifferencesPropTypes,
    functionalCurrency: PropTypes.string,

    environmentSuffix: PropTypes.string.isRequired,

    shouldDisplayZero: PropTypes.bool.isRequired,
    hideDecimals: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,

    downloadProvisionDetails: PropTypes.func.isRequired,
    isDownloadingProvisionDetails: PropTypes.bool.isRequired,
  };

  state = {
    activeTab: TabTypes.TAX_EXPENSE_REPORT,
  };

  componentDidMount() {
    const { companyCode, hasViewAccess, fetchProvisionData } = this.props;
    if (hasViewAccess) {
      fetchProvisionData(companyCode, true);
    }
  }

  changeTab = tabType => {
    this.setState({
      activeTab: tabType,
    });
  };

  navigateToTaxExpenseReportTab = () => {
    this.changeTab(TabTypes.TAX_EXPENSE_REPORT);
  };

  navigateToTrialBalanceTab = () => {
    this.changeTab(TabTypes.TRIAL_BALANCE);
  };

  selectCompanyCode = companyCode => {
    const value = companyCode ? companyCode.value : null;
    this.props.selectCompanyCode(value);
    this.props.fetchProvisionData(value, true);
  };

  selectPeriod = selectedPeriod => {
    const { periods } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    this.props.selectPeriod(periods.find(period => period.name === value));
    this.props.fetchProvisionData(this.props.companyCode, true);
  };

  calculateProvision = () => {
    const { calculateProvision, companyCode, general, period } = this.props;
    const { businessUnit } = general.companyCodeDetails;

    calculateProvision({ businessUnit, companyCode, period });
  };

  proformaCalc = () => {
    const { proformaCalc, companyCode, period } = this.props;

    proformaCalc({ companyCode, period });
  };

  downloadProvisionDetail = () => {
    const {
      companyCode,
      period,
      general,
      taxExpense,
      trialBalanceCollection,
      journalsCollection,
      localJournalsCollection,
      journalsDetailCollection,
      adjustments: {
        adjustmentsCollection,
        bookToTaxDifferencesCollection,
      },
      taxRates,
      taxAccounting,
      bookToTaxDifferences,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    } = this.props;

    this.props.downloadProvisionDetails({
      companyCode,
      period,
      general,
      taxExpense,
      trialBalanceCollection,
      journalsCollection,
      localJournalsCollection,
      journalsDetailCollection,
      adjustmentsCollection,
      bookToTaxDifferencesCollection,
      taxRates,
      taxAccounting,
      bookToTaxDifferences,
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
      environmentSuffix,
    });
  };

  uploadTrialBalanceFile = file => {
    const { companyCode, companyCodes, period, uploadTrialBalanceFile, general } = this.props;
    const {
      companySource,
      chartName,
    } = general.companyCodeDetails;

    this.navigateToTrialBalanceTab();
    uploadTrialBalanceFile({ companyCode, companyCodes, file, period, companySource, chartName });
  };

  render() {
    const {
      companyCode,
      companyCodes,
      period,
      general,
      adjustments,
      fetchingInitialProvisionData,
      isCalculatingProvision,
      isProformaCalc,
      isUploadingTrialBalance,
      isMultiTaxNonUS,
      hasViewAccess,
      functionalCurrency,

      addEditAdjustmentModal,
      deleteAdjustmentModal,
      hideAdjustmentModalForAddEdit,
      hideDeleteModal,
      attachmentsModal,
      cannotUploadTrialBalance,
      cannotCalculateTrialBalance,
      cannotUploadMessageModal,
      showCannotUploadMessageModal,
      hideCannotUploadMessageModal,
      cannotCalculateMessageModal,
      batchCalculationModal,
      showCannotCalculateMessageModal,
      hideCannotCalculateMessageModal,
      hideBatchCalculationModal,
      errorMessage,
      cannotDownloadCompanyDetails,

      environmentSuffix,

      isDownloadingProvisionDetails,
    } = this.props;

    const { activeTab } = this.state;

    const {
      companySource,
      chartName,
    } = general.companyCodeDetails;
    const { statusName } = general;
    const { showDeleteModal, showAttachmentsModal } = adjustments;

    return (
      <div className="provision-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
          <Select
            className="select-provision"
            clearable={false}
            disabled={!period}
            name="companyCode"
            options={companyCodes}
            onChange={this.selectCompanyCode}
            scrollMenuIntoView={false}
            value={companyCode}
            placeholder="Select a Provision"
            virtualized
          />
          <div className="hamburger-dropdown ml-auto text-right">
            <HamburgerDropdown
              calculateProvision={this.calculateProvision}
              proformaCalc={this.proformaCalc}
              cannotDownloadCompanyDetails={cannotDownloadCompanyDetails}
              downloadProvisionDetail={this.downloadProvisionDetail}
              cannotUploadTrialBalance={cannotUploadTrialBalance}
              showCannotUploadMessageModal={showCannotUploadMessageModal}
              cannotCalculateTrialBalance={cannotCalculateTrialBalance}
              showCannotCalculateMessageModal={showCannotCalculateMessageModal}
              uploadTrialBalanceFile={this.uploadTrialBalanceFile}
              isCalculatingProvision={isCalculatingProvision}
              isProformaCalc={isProformaCalc}
              isUploadingTrialBalance={isUploadingTrialBalance}
              onCalculateProvisionFinish={this.navigateToTaxExpenseReportTab}
              onTrialBalanceUploadFinish={this.navigateToTrialBalanceTab}
              companySource={companySource}
              chartName={chartName}
              period={period}
              companyCode={companyCode}
              functionalCurrency={functionalCurrency}
              environmentSuffix={environmentSuffix}
              isDownloadingProvisionDetails={isDownloadingProvisionDetails}
            />
          </div>
        </SecondaryMenu>

        <div className="page">
          {!companyCode && !errorMessage ? <NoDataToDisplay header="No Provision Selected" details="Please select a provision to view." /> : null}
          {companyCode && errorMessage ? <NoDataToDisplay header={errorMessage} /> : null}
          {companyCode && !errorMessage && !hasViewAccess ? <AccessRestricted/> : null}
          {companyCode && !errorMessage && hasViewAccess ? (
            <div className="container-fluid">
              <ReduxAlert/>
              {!fetchingInitialProvisionData && companySource
                ? (
                  <div className="row no-gutters">
                    <div className="col-md-12">
                      <ProvisionDetails
                        activeTab={activeTab}
                        changeTab={this.changeTab}
                        companySource={companySource}
                        chartName={chartName}
                        statusName={statusName}
                        showDeleteModal={showDeleteModal}
                        showAttachmentsModal={showAttachmentsModal}
                      />
                    </div>
                  </div>
                )
                : <Spinner global />
              }
            </div>
          ) : null}
        </div>
        <AddEditAdjustmentModal
          hideModal={hideAdjustmentModalForAddEdit}
          isVisible={addEditAdjustmentModal.show}
          openForEdit={Boolean(addEditAdjustmentModal && addEditAdjustmentModal.data)}
          entityToEdit={addEditAdjustmentModal && addEditAdjustmentModal.data}
          isMultiTaxNonUS={isMultiTaxNonUS}
        />
        <CannotUploadMessageModal
          hideModal={hideCannotUploadMessageModal}
          isVisible={cannotUploadMessageModal.show}
        />
        <DeleteAdjustmentModal
          hideModal={hideDeleteModal}
          entityToRemove={deleteAdjustmentModal.data}
          isVisible={deleteAdjustmentModal.show}
        />
        <CannotCalculateMessageModal
          hideModal={hideCannotCalculateMessageModal}
          isVisible={cannotCalculateMessageModal.show}
        />
        <BatchCalculationModal
          hideModal={hideBatchCalculationModal}
          isVisible={batchCalculationModal.show}
        />
        <AttachmentsModal isVisible={attachmentsModal.show} adjustment={attachmentsModal.data} />
        <ReactTooltip effect="float" className="z-index-1000"/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { shared, provision } = state;

  return {
    companyCode: companyCodeSelector(state),
    companyCodes: companyCodesOptions(state),
    cannotUploadTrialBalance: cannotUploadTrialBalanceSelector(state),
    cannotCalculateTrialBalance: cannotCalculateTrialBalanceSelector(state),
    cannotDownloadCompanyDetails: cannotDownloadCompanyDetailsSelector(state),
    period: periodOrCurrentSelector(state),
    periods: periodsSelector(state),
    general: provision.general,
    fetchingInitialProvisionData: shared.fetchingInitialProvisionData,
    adjustments: adjustmentsSelector(state),
    isCalculatingProvision: provision.general.isCalculatingProvision,
    isProformaCalc: provision.general.isProformaCalc,
    isUploadingTrialBalance: provision.general.isUploadingTrialBalance,
    isDownloadingProvisionDetails: isDownloadingProvisionDetailsSelector(state),
    isMultiTaxNonUS: provision.general.isMultiTaxNonUS,
    addEditAdjustmentModal: modalDataSelector(state, ModalNames.AdjustmentAddEdit),
    deleteAdjustmentModal: modalDataSelector(state, ModalNames.AdjustmentDelete),
    cannotUploadMessageModal: modalDataSelector(state, ModalNames.CannotUploadMessage),
    cannotCalculateMessageModal: modalDataSelector(state, ModalNames.CannotCalculateMessage),
    batchCalculationModal: modalDataSelector(state, ModalNames.BatchCalculation),
    attachmentsModal: modalDataSelector(state, ModalNames.Attachments),
    uploadTrialBalanceModal: modalDataSelector(state, ModalNames.UploadTrialBalance),
    errorMessage: shared.errorMessage,
    functionalCurrency: shared.provisionfunctionalCurrency,

    taxExpense: provision.general.taxExpense,
    trialBalanceCollection: provision.trialBalance.trialBalanceCollection,
    journalsCollection: provision.general.journals,
    localJournalsCollection: provision.general.localJournals,
    journalsDetailCollection: provision.general.journalsDetail,
    taxRates: provision.general.taxRates,
    taxAccounting: provision.general.taxAccounting,
    bookToTaxDifferences: provision.general.bookToTaxDifferences,

    environmentSuffix: environmentSuffixSelector(state),

    shouldDisplayZero: displayZeroSelector(state),
    hideDecimals: hideDecimalsSelector(state),
    negativeMinus: negativeMinusSelector(state),

  };
};

export default compose(
  withViewPermission(),
  connect(mapStateToProps, {
    fetchProvisionData,
    selectCompanyCode,
    selectPeriod,
    calculateProvision,
    proformaCalc,
    hideBatchCalculationModal,
    showCannotCalculateMessageModal,
    hideCannotCalculateMessageModal,
    showCannotUploadMessageModal,
    hideCannotUploadMessageModal,
    uploadTrialBalanceFile,
    hideAdjustmentModalForAddEdit,
    hideDeleteModal,
    downloadProvisionDetails,
  })
)(ProvisionPage);
